import { render, staticRenderFns } from "./LessonItem.vue?vue&type=template&id=20ec118c&scoped=true"
import script from "./LessonItem.vue?vue&type=script&lang=js"
export * from "./LessonItem.vue?vue&type=script&lang=js"
import style0 from "./LessonItem.vue?vue&type=style&index=0&id=20ec118c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ec118c",
  null
  
)

export default component.exports